import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    // styleUrls: ['./app.component.css']
    styles: [`
 h3{
   color:dodgerblue;
 }
 `],
    standalone: false
})
export class AppComponent {
  
}
